import React from 'react';
import RoomCardElement from './RoomCardElement';

const RoomCardList = ({ items = [] }) => {
  return (<>
    {
      items.map((item, index) => {
        return (<RoomCardElement key={'room_' + index} room={item} />)
      })
    }
  </>);
};


export default React.memo(RoomCardList);
